// @flow

type ErrorObject = {
  [key: string]: ?string
}

type FieldValidator = {
  field: string,
  validator: (value: any) => ?ErrorObject
}

const createSyncValidator = (...fieldsValidators: FieldValidator[]) => values => {
  const errors = fieldsValidators.reduce((acc, { field, validator }) => {
    const value = values.get ? values.get(field) : values[field]
    const error = validator(value)
    if (Array.isArray(error)) {
      return {
        ...acc,
        [field]: error
      }
    }
    return {
      ...acc,
      ...error
    }
  }, {})
  if (Object.keys(errors).length) {
    return errors
  }
}

export default createSyncValidator
